export default "__VITE_ASSET__6685994f__"